import Vue from 'vue';

Vue.mixin({
  created() {
    if (this.$options.components && this.$options.components['el-dialog']) {
      this.$options.components['el-dialog'].props.modalAppendToBody.default = false;
    }
  }
});